import { SvgIcon } from "@mui/material";

export default function SidebarPanelIcon(props) {
  return (
    <SvgIcon viewBox="0 0 24 24" fill="none" {...props}>
      <rect
        x="5"
        y="4"
        width="16"
        height="16"
        rx="3.5"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
      />
      <path
        d="M9.25 4.5V19.5"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
      />
    </SvgIcon>
  );
}
